/* Product image alt-text tooltip. Only loaded on product pages.
   Observer is scoped to the product section, not document.body. */
(function () {
  'use strict';

  var SELECTORS = [
    '.product-gallery-img-slider img',
    '.product-thumbnail-inner img',
    '.product-gallery-img-item img',
  ].join(', ');
  var OFFSET_X = 12;
  var OFFSET_Y = 20;

  var tooltip = document.createElement('div');
  tooltip.className = 'gs-tooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.setAttribute('aria-hidden', 'true');
  tooltip.innerHTML = '<div class="gs-tooltip__inner"></div>';
  document.body.appendChild(tooltip);
  var inner = tooltip.querySelector('.gs-tooltip__inner');
  var currentTarget = null;
  var showTimer = null;

  function getAlt(img) {
    return (img.getAttribute('alt') || '').trim();
  }
  function show(img, e) {
    var text = getAlt(img);
    if (!text) return;
    inner.textContent = text;
    position(e);
    tooltip.classList.add('gs-tooltip--visible');
  }
  function hide() {
    tooltip.classList.remove('gs-tooltip--visible');
    currentTarget = null;
  }
  function position(e) {
    var x = e.clientX + OFFSET_X;
    var y = e.clientY + OFFSET_Y;
    var tw = tooltip.offsetWidth;
    var th = tooltip.offsetHeight;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    if (x + tw > vw - 10) x = e.clientX - tw - OFFSET_X;
    if (y + th > vh - 10) y = e.clientY - th - 8;
    tooltip.style.left = x + 'px';
    tooltip.style.top = y + 'px';
  }

  function attachToImages() {
    document.querySelectorAll(SELECTORS).forEach(function (img) {
      if (img.dataset.gsTooltip) return;
      img.dataset.gsTooltip = '1';
      img.addEventListener('mouseenter', function (e) {
        currentTarget = img;
        clearTimeout(showTimer);
        showTimer = setTimeout(function () {
          if (currentTarget === img) show(img, e);
        }, 120);
      });
      img.addEventListener('mousemove', function (e) {
        if (currentTarget === img) position(e);
      });
      img.addEventListener('mouseleave', function () {
        clearTimeout(showTimer);
        hide();
      });
    });
  }

  function init() {
    attachToImages();

    // Scope the observer to the product section, not document.body.
    // Falls back gracefully if no product section is present.
    var scope =
      document.querySelector('.main-product-section') ||
      document.querySelector('[data-product-wrapper]') ||
      document.querySelector('product-info');
    if (!scope) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          attachToImages();
          return;
        }
      }
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
